import { render, staticRenderFns } from "./GameWheel.vue?vue&type=template&id=ac7d5e44&"
import script from "./GameWheel.vue?vue&type=script&lang=js&"
export * from "./GameWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports